"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React, { useState } from "react"
import Grid from "@mui/material/Grid" // Grid version 2
import Typography from "@mui/material/Typography"
import map from "lodash/map"
import GroupTypeOrb from "./components/GroupTypeOrb"
import Header from "../shared/Header"
import SectionContainer from "../shared/SectionContainer"
import PrimaryAndSecondaryButtonsContainer from "../shared/PrimaryAndSecondaryButtonsContainer"
import useRedirectToLeaderOnboarding from "../../../../hooks/useRedirectToLeaderOnboarding"

import {
  GROUP_TYPE_WORKSHOP,
  GROUP_TYPE_THERAPY_GROUP,
  GROUP_TYPE_SUPPORT_GROUP,
  GROUP_TYPE_RETREATS,
  GROUP_TYPE_CLINICAL_PEER_GROUP,
  PRIMARY_BLACK_BUTTON_TYPE,
  SECONDARY_BUTTON_TYPE,
} from "../shared/constants"

const GROUP_TYPES = [
  GROUP_TYPE_WORKSHOP,
  GROUP_TYPE_THERAPY_GROUP,
  GROUP_TYPE_SUPPORT_GROUP,
  GROUP_TYPE_RETREATS,
  GROUP_TYPE_CLINICAL_PEER_GROUP,
]
function WhatGroupTypes() {
  const [
    { isLoggedIn },
    { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler },
  ] = useRedirectToLeaderOnboarding()
  const [groupTypeOrbOpen, setGroupTypeOrbOpen] = useState(false)
  const renderHeader = () => {
    return <Header text="What group types are here" />
  }

  const renderBody = () => {
    return (
      <div className={""}>
        <Typography variant={"body1"}>
          Groups are created and <b>led independently</b> by mental wellness
          professionals. All groups posted here are interactive face-to-face
          experiences. No one-sided lectures or fully pre-recorded sessions.
        </Typography>
      </div>
    )
  }

  const renderGridOrbItem = ({ groupType, index }) => {
    return (
      <Grid
        key={`orb-${index}`}
        size={{
          xs: 6,
          sm: 6,
          md: 4,
          lg: 2.4,
        }}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <GroupTypeOrb
          groupType={groupType}
          groupTypeOrbOpen={groupTypeOrbOpen == groupType}
          setGroupTypeOrbOpen={setGroupTypeOrbOpen}
        />
      </Grid>
    )
  }

  const renderGroupTypeOrbs = () => {
    return (
      <div className={"relative top-[10px] min-[600px]:top-[20px]"}>
        <Grid
          container
          columnSpacing={{ xs: 1, sm: 1, md: 4 }}
          rowSpacing={5}
          sx={{
            justifyContent: "center",
            alignItems: "flex-start",
            padding: 0,
            margin: 0,
          }}
        >
          {map(GROUP_TYPES, (groupType, index) => {
            return renderGridOrbItem({ groupType, index })
          })}
        </Grid>
      </div>
    )
  }

  const renderButtons = () => {
    return (
      <PrimaryAndSecondaryButtonsContainer
        button1={{
          type: PRIMARY_BLACK_BUTTON_TYPE,
          text: "Post your group",
          href: getRouteForLeaderOnboarding(),
        }}
        button2={{
          type: SECONDARY_BUTTON_TYPE,
          text: "Get monthly listings",
          onClick: async () => {
            getMonthlyListingsClickHandler()
          },
        }}
      />
    )
  }

  return (
    <SectionContainer>
      <div className={"min-[600px]:mt-[67px]"}>
        {renderHeader()}
        {renderBody()}
        {renderGroupTypeOrbs()}
        {renderButtons()}
      </div>
    </SectionContainer>
  )
}
export default WhatGroupTypes
